import React, { useState, useRef, useEffect } from "react";
import styles from "./Input.module.scss";
import cx from "classnames";

interface InputProps {
  value: string;
  type: string;
  focused?: boolean;
  placeholder?: string;
  onChange: (e: any) => void;
  onFocus: () => void;
  onBlur: () => void;
  className?: string;
  error?: boolean;
}

const Input: React.FC<InputProps> = ({
  value,
  type,
  focused,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  className,
  error,
}) => {
  const [inputFocused, setInputFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleLabelClick = () => {
    setInputFocused(true);
    onFocus();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleInputBlur = () => {
    setInputFocused(false);
    onBlur();
  };

  useEffect(() => {
    if (focused) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  }, [focused]);

  return (
    <div className={styles.root_main}>
      <label
        className={`${styles.root_main_placeholder} ${
          focused || value || inputFocused ? styles.focused : ""
        }`}
        onClick={handleLabelClick}
      >
        {placeholder}
      </label>
      <input
        className={cx(
          error ? styles.root_main_error : styles.root_main_input,
          className
        )}
        value={value}
        type={type}
        onFocus={onFocus}
        onBlur={handleInputBlur}
        onChange={onChange}
        ref={inputRef}
      />
    </div>
  );
};

export default Input;
